// extracted by mini-css-extract-plugin
export default {"PermissoesObrasTabWrapper":"PermissoesObrasTab_PermissoesObrasTabWrapper__GszmU"};